import { Alert, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Toast, Tooltip } from 'bootstrap'
import '@popperjs/core';

let Bootstrap = {
    run: () => {

        window.bootstrap = { Alert, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Toast, Tooltip }

        let TooltipList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        TooltipList.map(function (el) { return new Tooltip(el) })

    }
}

export default Bootstrap;
